export default __webpack_public_path__ + "static/media/11.edec3bd1.webp";